import { IconBaseProps } from "react-icons";

export function SolutionsIcon(props: IconBaseProps) {
  const { size = 24, color = "currentColor", ...rest } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M23.5 17L18.5 22L15 18.5L16.5 17L18.5 19L22 15.5L23.5 17ZM20.5 11C21.163 11 21.7989 11.2634 22.2678 11.7323C22.7366 12.2011 23 12.837 23 13.5C23 13.81 22.94 14.11 22.84 14.39C21.8 13.5 20.46 13 19 13C15.69 13 13 15.69 13 19V19.54C12.64 18.5 11.65 17.8 10.5 17.8C9 17.8 7.8 19 7.8 20.5V22H4C2.9 22 2 21.1 2 20V16.2H3.5C5 16.2 6.2 15 6.2 13.5C6.2 12 5 10.8 3.5 10.8H2V7.00005C2 6.46961 2.21071 5.96091 2.58579 5.58583C2.96086 5.21076 3.46957 5.00005 4 5.00005H8V3.50005C8 2.12005 9.12 0.998047 10.5 0.998047C11.88 0.998047 13 2.12005 13 3.50005V5.00005H17C17.5304 5.00005 18.0391 5.21076 18.4142 5.58583C18.7893 5.96091 19 6.46961 19 7.00005V11H20.5Z"
        fill={color}
      />
    </svg>
  );
}
